import { render } from "./platform.vue?vue&type=template&id=3db6119f&scoped=true"
import script from "./platform.vue?vue&type=script&lang=js"
export * from "./platform.vue?vue&type=script&lang=js"

import "./platform.vue?vue&type=style&index=0&id=3db6119f&scoped=true&lang=less"

import exportComponent from "D:\\A-daima\\前端\\前台\\前台\\nonferrous_metals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db6119f"]])

export default __exports__